__turbopack_context__.v({
  "copyright": "Footer-module__Grjkva__copyright",
  "footer": "Footer-module__Grjkva__footer",
  "navItems": "Footer-module__Grjkva__navItems",
});
